import { URL_Route } from "./urlRouts";

// ********************LOGIN & REGISTER***********************
// LAYOUTS
import LoginLayout from "./Layouts/DesktopLayouts/LoginLayout";
import LoginMobileLayout from "./Layouts/MobileLayouts/LoginMobileLayout";

// JS FUNCTIONS
import Login from "./JsFunctions/Auth/Login";

// COMPONENTS
import LoginDesktopPage from "./pages/DesktopPages/AuthPages/LoginPage";
import LoginMobilePage from "./pages/MobilePages/AuthPages/LoginMobilePage";

// ********************DASHBOARD***********************
// JS FUNCTIONS
import Dashboard from "./JsFunctions/Dashboard/Dashboard";
import ContactRequest from "./JsFunctions/Dashboard/ContactRequest";
import AgentRequest from "./JsFunctions/Dashboard/AgentRequest";
import RentalRequest from "./JsFunctions/Dashboard/RentalRequest";
import SubmitedPropertyRequest from "./JsFunctions/Dashboard/SubmitedPropertyRequest";
import PropertyList from "./JsFunctions/Dashboard/PropertyList";
import ListAgent from "./JsFunctions/Dashboard/ListAgent";
import AddAgent from "./JsFunctions/Dashboard/AddAgent";
import EditAgent from "./JsFunctions/Dashboard/EditAgent";
import RegionSort from "./JsFunctions/Dashboard/RegionSort";
import AddProperty from "./JsFunctions/Dashboard/AddProperty";
import EditProperty from "./JsFunctions/Dashboard/EditProperty";
import BaseInfo from "./JsFunctions/Dashboard/BaseInfo";
import Logout from "./JsFunctions/Dashboard/Logout";
import Page404 from "./JsFunctions/Dashboard/Page404";
import AboutUs from "JsFunctions/Dashboard/AboutUs";

// DESKTOP PAGES
import DashboardDesktopPage from "./pages/DesktopPages/PanelPages/DashboardPage";
import RequestDesktopPage from "./pages/DesktopPages/PanelPages/RequestsPage";
import RentalRequestDesktopPage from "./pages/DesktopPages/PanelPages/RentalRequestPage";
import SubmitedPropertyRequestDesktopPage from "./pages/DesktopPages/PanelPages/SubmitedPropertyRequestPage";
import PropertyListDesktopPage from "./pages/DesktopPages/PanelPages/PropertyListPage";
import ListAgentDesktopPage from "./pages/DesktopPages/PanelPages/ListAgentPage";
import AddAgentDesktopPage from "./pages/DesktopPages/PanelPages/AddAgentPage";
import EditAgentDesktopPage from "./pages/DesktopPages/PanelPages/EditAgentPage";
import RegionSortDesktopPage from "./pages/DesktopPages/PanelPages/RegionSortPage";
import AddPropertyDesktopPage from "./pages/DesktopPages/PanelPages/AddPropertyPage";
import EditPropertyDesktopPage from "./pages/DesktopPages/PanelPages/EditPropertyPage";
import BaseInfoDesktopPage from "./pages/DesktopPages/PanelPages/BaseInfoPage";
import Page404Desktop from "./pages/DesktopPages/PanelPages/Page404";
import AboutUsPage from "pages/DesktopPages/PanelPages/AboutUsPage";

// MOBILE PAGES
import DashboardMobilePage from "./pages/MobilePages/PanelPages/DashboardMobilePage";
import RequestsMobilePage from "./pages/MobilePages/PanelPages/RequestsMobilePage";
import RentalRequestMobilePage from "./pages/MobilePages/PanelPages/RentalRequestMobilePage";
import SubmitedPropertyRequestMobilePage from "./pages/MobilePages/PanelPages/SubmitedPropertyRequestMobilePage";
import PropertyListMobilePage from "./pages/MobilePages/PanelPages/PropertyListMobilePage";
import ListAgentMobilePage from "./pages/MobilePages/PanelPages/ListAgentMobilePage";
import AddAgentMobilePage from "./pages/MobilePages/PanelPages/AddAgentMobilePage";
import EditAgentMobilePage from "./pages/MobilePages/PanelPages/EditAgentMobilePage";
import RegionSortMobilePage from "./pages/MobilePages/PanelPages/RegionSortMobilePage";
import AddPropertyMobilePage from "./pages/MobilePages/PanelPages/AddPropertyMobilePage";
import EditPropertyMobilePage from "./pages/MobilePages/PanelPages/EditPropertyMobilePage";
import BaseInfoMobilePage from "./pages/MobilePages/PanelPages/BaseInfoMobilePage";
import AboutUsMobilePage from "pages/MobilePages/PanelPages/AboutUsMobilePage";

export const routes = [
  {
    path: URL_Route.Login,
    protected: false,
    name: "Login",
    hasLayout: true,
    JsFunction: Login,
    DesktopComponent: LoginDesktopPage,
    MobileComponent: LoginMobilePage,
    DesktopLayout: LoginLayout,
    MobileLayout: LoginMobileLayout,
  },
  {
    path: URL_Route.Default,
    protected: true,
    name: "Dashboard",
    JsFunction: Dashboard,
    DesktopComponent: DashboardDesktopPage,
    MobileComponent: DashboardMobilePage,
  },
  {
    path: URL_Route.Panel,
    protected: true,
    name: "Dashboard",
    JsFunction: Dashboard,
    DesktopComponent: DashboardDesktopPage,
    MobileComponent: DashboardMobilePage,
  },
  {
    path: URL_Route.Contact_Request,
    protected: true,
    name: "Contact Request",
    JsFunction: ContactRequest,
    DesktopComponent: RequestDesktopPage,
    MobileComponent: RequestsMobilePage,
  },
  {
    path: URL_Route.Agent_Request,
    protected: true,
    name: "Agent Request",
    JsFunction: AgentRequest,
    DesktopComponent: RequestDesktopPage,
    MobileComponent: RequestsMobilePage,
  },
  {
    path: URL_Route.Rental_Request,
    protected: true,
    name: "Rental Request",
    JsFunction: RentalRequest,
    DesktopComponent: RentalRequestDesktopPage,
    MobileComponent: RentalRequestMobilePage,
  },
  {
    path: URL_Route.Submited_Property,
    protected: true,
    name: "Submited Property",
    JsFunction: SubmitedPropertyRequest,
    DesktopComponent: SubmitedPropertyRequestDesktopPage,
    MobileComponent: SubmitedPropertyRequestMobilePage,
  },
  {
    path: URL_Route.Property_List,
    protected: true,
    name: "Property List",
    JsFunction: PropertyList,
    DesktopComponent: PropertyListDesktopPage,
    MobileComponent: PropertyListMobilePage,
  },
  {
    path: URL_Route.List_Agent,
    protected: true,
    name: "List Agent",
    JsFunction: ListAgent,
    DesktopComponent: ListAgentDesktopPage,
    MobileComponent: ListAgentMobilePage,
  },
  {
    path: URL_Route.Add_Agent,
    protected: true,
    name: "Add Agent",
    JsFunction: AddAgent,
    DesktopComponent: AddAgentDesktopPage,
    MobileComponent: AddAgentMobilePage,
  },
  {
    path: URL_Route.Edit_Agent,
    protected: true,
    name: "Edit Agent",
    JsFunction: EditAgent,
    DesktopComponent: EditAgentDesktopPage,
    MobileComponent: EditAgentMobilePage,
  },
  {
    path: URL_Route.Region_Sort,
    protected: true,
    name: "Region Sort",
    JsFunction: RegionSort,
    DesktopComponent: RegionSortDesktopPage,
    MobileComponent: RegionSortMobilePage,
  },
  {
    path: URL_Route.Add_Property,
    protected: true,
    name: "Add Property",
    JsFunction: AddProperty,
    DesktopComponent: AddPropertyDesktopPage,
    MobileComponent: AddPropertyMobilePage,
  },
  {
    path: URL_Route.Edit_Property,
    protected: true,
    name: "Edit Property",
    JsFunction: EditProperty,
    DesktopComponent: EditPropertyDesktopPage,
    MobileComponent: EditPropertyMobilePage,
  },
  {
    path: URL_Route.Base_Info,
    protected: true,
    name: "Base Info",
    JsFunction: BaseInfo,
    DesktopComponent: BaseInfoDesktopPage,
    MobileComponent: BaseInfoMobilePage,
  },
  {
    path: URL_Route.About_us,
    protected: true,
    name: "About Us",
    JsFunction: AboutUs,
    DesktopComponent: AboutUsPage,
    MobileComponent: AboutUsMobilePage,
  },
  {
    path: URL_Route.Log_Out,
    protected: true,
    name: "LogOut",
    JsFunction: Logout,
  },
  {
    path: URL_Route.Log_Out,
    protected: false,
    name: "LogOut",
    JsFunction: Logout,
  },
  {
    path: URL_Route.PanelPage404,
    protected: true,
    name: "404",
    JsFunction: Page404,
    DesktopComponent: Page404Desktop,
    MobileComponent: Page404Desktop,
  },
  {
    path: URL_Route.Page404,
    protected: false,
    name: "404",
    Component: Page404,
  },
];
